import React, { useState } from "react";
import "./product.css";

export default function Product({ data, idx }) {
  var position = idx % 2 === 1 ? "right" : "left";
  const [toggleForm, setToggleForm] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState();
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log({ name, email, number });
    setName("");
    setEmail("");
    setNumber("");
    setToggleForm(!toggleForm);
  };
  return (
    <div
      className={`scrobits__product-outer__contiainer background-${position}`}
    >
      <div
        className={`toggle-product__demo_from form-${toggleForm ? "show" : ""}`}
      >
        <form onSubmit={handleSubmit}>
          <div className="text-center">Fill below form for demo</div>
          <div className="form-group">
            <input
              type="text"
              name="fullName"
              id="fullName"
              className="form__input"
              placeholder=" "
              required
              value={name}
              onChange={(e) => {
                setName(e.currentTarget.value);
              }}
            />
            <label htmlFor="fullName" className="form__label">
              Full Name
            </label>
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              id="email"
              className="form__input"
              placeholder=" "
              value={email}
              onChange={(e) => {
                setEmail(e.currentTarget.value);
              }}
            />
            <label htmlFor="email" className="form__label">
              Email
            </label>
          </div>
          <div className="form-group">
            <input
              type="number"
              name="phoneNumber"
              id="phoneNumber"
              value={number}
              className="form__input"
              placeholder=" "
              onChange={(e) => {
                setNumber(e.currentTarget.value);
              }}
            />
            <label htmlFor="phoneNumber" className="form__label">
              Phone Number
            </label>
          </div>
          <div className="form-group">
            <button className="form-submit-btn" type="submit">
              Request demo
            </button>
          </div>
        </form>
      </div>
      <div className={`scrobits__product-container ${position}`}>
        <div className="scrobits__product-img__container">
          <img src={data.imgUrl} alt={data.title} />
          {data.discount && (
            <div className="product__discount">{data.discount.name}</div>
          )}
        </div>
        <div className="scrobits__product-info">
          <p className="gradient__text">{data.shortTitle}</p>
          <h2>{data.title}</h2>
          <p>{data.description}</p>
          <div>
            {data.discount && (
              <div className="product__discount">
                {data.discount.offerValue}$
              </div>
            )}
            <div
              className={`product__price ${
                !data.discount ? "" : "disc__availe"
              }`}
            >
              {" " + data.price + " "}$
            </div>
          </div>
          {data.rate && (
            <>
              <div>
                {data.rate.rateCount}{" "}
                <span className="scrobits__product-rating">
                  {" "}
                  ({data.rate.count})
                </span>
              </div>
            </>
          )}
          <div>
            <button
              onClick={() => {
                setToggleForm(!toggleForm);
              }}
              className="scrobits__product-btn"
            >
              Request Demo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
